import { Stack } from 'common/ui/Layout';
import { Toolbar } from 'common/ui/Toolbar';

import { RightDrawerProvider } from '../Reporter/RightDrawer/useRightDrawer';
import { BlankRouteRightDrawer } from './BlankRouteRightDrawer';
import { PicklistStoreProvider } from '../Template/usePicklist';
import { ListStoreProvider } from '../RichTextEditor/plugins/list/hooks/useCurrentList';

const ReporterBlankRoute = (): React.ReactElement | null => {
  return (
    <Stack vertical css="width: 100%; height: 100%">
      <Toolbar>
        <div />
      </Toolbar>

      <RightDrawerProvider>
        <main
          style={{
            display: 'flex',
            flex: '1 1 auto',
            flexGrow: 1,
            overflow: 'hidden',
            paddingRight: 0,
          }}
        >
          <Stack
            vertical
            css="width: 100%; height: 100%"
            alignX="center"
            alignY="center"
            space="large"
          />
          <PicklistStoreProvider initialPicklists={[]} initialMacros={[]}>
            <ListStoreProvider>
              <BlankRouteRightDrawer />
            </ListStoreProvider>
          </PicklistStoreProvider>
        </main>
      </RightDrawerProvider>
    </Stack>
  );
};

ReporterBlankRoute.displayName = 'ReporterBlankRoute';

export default ReporterBlankRoute;
